import ClientBase from "../ClientBase";

/**
 * Human-added ground-truth boxes for anomalies the model missed (false
 * negatives). Duallo admin only. Feeds the retraining export alongside
 * reviewed marker provenance.
 */
class MarkerGroundTruthClient extends ClientBase {

    async getByScanId(scanId) {
        return await this.get(`api/v1/markergroundtruth/scans/${scanId}`) ?? [];
    }

    async create(request) {
        return await this.post('api/v1/markergroundtruth', request);
    }

    async deleteById(scanId, id) {
        return await this.delete(`api/v1/markergroundtruth/scans/${scanId}/${id}`);
    }
}

export default new MarkerGroundTruthClient();
